import { Component, OnInit, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { AuthenticationService } from '../core/services/authentication.service';
import { CommonService } from '../shared/services/common.service';
import { Router } from '@angular/router';
import {  Subscription } from 'rxjs';
import * as appApiResources from '../shared/globalcontants';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment-timezone';
import { NgClass } from '@angular/common';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatFormField } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, MatMenuTrigger, MatMenu, MatFormField, MatSelect, MatOption]
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  public tooglebool: boolean;
  public selected = 'option2';
  public name = 'message';
  public siteAbbreviation = this._cs.siteAbbreviation;
  public showLogin: boolean;
  public showNewMessage: boolean;
  public globalSettings: string;
  public checkModeSubscription: Subscription;
  public showAppHeaderSubscription: Subscription;
  public showAppHeader: boolean;
  public SiteFullName: string;
  private messageConfig: any;
  showLogo: boolean;
  timezoneDescription: string;
  interval: any;
  currentDateInfo: string;
  currentTimeInfo: string;
  @HostListener("click", ['$event'])
  clicked(event) {
    const clickCheck = event.target.classList.value.includes('circle-button') || event.target.classList.value.includes('fil-circle');
    if (!clickCheck) {
      const div = document.getElementById('siteMenu_text')?.click()
    }
  }
  @ViewChild('appHeader') appHeader: ElementRef;

  constructor(private authentication: AuthenticationService,
    private _cs: CommonService,
    private router: Router,
    private _ts: TranslateService) {
    this.showLogin = this._cs.showSettingLogin;
    this.tooglebool = _cs.toogleOpen;
    this.showLogo = this._cs.IsRguest;
    this.globalSettings = this._ts.instant('setting.globalSettings');
    this.showNewMessage = this._cs.showNewMessage;

    const messageconf = this._cs.getMenuItemList().filter((item) => item.Name === 'Messages');
    if (messageconf && messageconf.length > 0 && messageconf[0]) {
      this.messageConfig = messageconf[0];
    }
    const timeFormat = appApiResources.TimeZoneDateTimeFormat?.replace(appApiResources.DefaultDateFormat, '');
    const dateFormat = localStorage.getItem(appApiResources.dateFormate) || appApiResources.DefaultDateFormat;
    this.timezoneDescription = localStorage.getItem(appApiResources.TimezoneDescription);
    moment.tz.setDefault(localStorage.getItem(appApiResources.TimeZone) || appApiResources.DefaultTimeZone);
    (moment as any).defaultFormat = appApiResources.PostDateTimeFormat;
    this.interval = setInterval(() => {
      const now = moment();
      this.currentDateInfo = now.format(dateFormat);
      this.currentTimeInfo = now.format(timeFormat);
    }, 1000);
  }

  tooglechange() {
    const booltoogle = (this._cs.toogleOpen) ? false : true;
    this._cs.ChangeToogle(booltoogle);
    // this._cs.toogleOpen = !this._cs.toogleOpen;
  }

  expandmenu() {
    this._cs.expandMenu = !this._cs.expandMenu;
    this._cs.slideOpen = !this._cs.slideOpen;
  }
ngAfterViewInit() {
this._cs.appHeaderElementRef = this.appHeader;
}

  ngOnInit() {
   this.showAppHeaderSubscription =  this._cs.showAppHeaderChange.subscribe((value) => {
      this.showAppHeader = value;
    });
    this.SiteFullName = sessionStorage.getItem(appApiResources.loggedInSiteFullName.toString());
  }

  messageClick() {
    this._cs.activeMenuChange.next('message');
    this._cs.ReceivingMenu = this.messageConfig.routerLink;
    if (this._cs.isonlineStatus) {

      if (this.messageConfig && this.messageConfig.routerLink) {
        this.router.navigate([this.messageConfig.routerLink]);
      } else {
        this._cs.routeClick(this.name);
      }
    } else {
      return ;
    }
  }

  logout() {
    this.authentication.logout();
  }

  goTologin() {
    this.router.navigate(['/login']);
  }
  ngOnDestroy(): void {
    this.showAppHeaderSubscription.unsubscribe();
  }


}
